import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62a42268")

_pushScopeId("data-v-62a42268")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "p-input-icon-left p-input-filled search" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search search__icon" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OInputText = _resolveComponent("OInputText")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_OInputText, {
        ref: "searchInput",
        modelValue: _ctx.modelValueComputed,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValueComputed = $event)),
        filled: "",
        class: "search__value",
        type: "text",
        "data-test": "searchInput",
        placeholder: _ctx.placeholder
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createVNode("div", {
      class: "cancel",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
    }, [
      _hoisted_4
    ])
  ]))
})